import { c as _c } from "react/compiler-runtime";
import type { Identity } from '@cc-shopping/platform-analytics/IdentityContext/identityService';
import { useEffect, useState } from 'react';
import type { Odds } from '.';
import { getLabelStartColumn } from './utils';
export type UseCreditScoreParams = {
  identity?: Identity;
  odds: Odds;
};
export function useUserCreditScore(t0) {
  const $ = _c(9);
  const {
    identity,
    odds
  } = t0;
  const [userCreditScore, setUserCreditScore] = useState();
  const [creditScalar, setCreditScalar] = useState(0.25);
  const [isBelowMin, setIsBelowMin] = useState(false);
  const {
    min
  } = odds;
  let t1;
  if ($[0] !== identity || $[1] !== min) {
    t1 = () => {
      if (identity && identity.creditScore) {
        setUserCreditScore(identity.creditScore / 850);
        setCreditScalar(getLabelStartColumn(identity.creditScore) * 0.25);
        if (identity.creditScore < min) {
          setIsBelowMin(true);
        }
      }
    };
    $[0] = identity;
    $[1] = min;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== identity) {
    t2 = [identity];
    $[3] = identity;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== creditScalar || $[6] !== isBelowMin || $[7] !== userCreditScore) {
    t3 = {
      userCreditScore,
      creditScalar,
      isBelowMin
    };
    $[5] = creditScalar;
    $[6] = isBelowMin;
    $[7] = userCreditScore;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}